import React from 'react';
import ProjectItemEditor from './ProjectItemEditor';
import { updateProjectsSection } from './ResumeEditorHelpers';

function ProjectsEditor({
  resumeHtml,
  currentThemeColor,
  editedData,
  setEditedData,
  setResumeHtml,
  resumeData,        // now available
  saveToHistory      // now available
}) {
  // Ensure projects is always an array.
  const projects = editedData?.projects || resumeData?.projects || [];

  const handleProjectDelete = (index) => {
    saveToHistory();
    const updatedProjects = projects.filter((_, idx) => idx !== index);
    setEditedData(prev => ({ ...prev, projects: updatedProjects }));
  };

  const handleProjectChange = (index, updatedProject) => {
    const updatedProjects = [...projects];
    updatedProjects[index] = updatedProject;
    setEditedData(prev => ({ ...prev, projects: updatedProjects }));
  };

  return (
    <div className="projects-editor">
      <h3>Edit Projects</h3>
      {projects.map((project, idx) => (
        <ProjectItemEditor
          key={idx}
          index={idx}
          project={project}
          onProjectChange={handleProjectChange}
          onProjectDelete={projects.length > 1 ? handleProjectDelete : undefined}
        />
      ))}

      <button onClick={() => {
        saveToHistory();
        const newEntry = { projectTitle: "", description: "" };
        const updated = [...projects, newEntry];
        setEditedData(prev => ({ ...prev, projects: updated }));
      }}>
        Add New Project
      </button>

      <button onClick={() => {
        const updatedHtml = updateProjectsSection(resumeHtml, projects);
        setResumeHtml(updatedHtml);
      }}>
        Update Projects
      </button>
    </div>
  );
}

export default ProjectsEditor;
